export const HUNDREDWEIGHT = "Hundredweight";
export const BY_THE_PALLET = "By the Pallet";
export const BY_THE_PALLET_WAREHOUSE_BUILT = "By the Pallet (Warehouse-Built)";
export const BY_THE_UNIT_ITEM = "By the Unit/Item";
export const BY_THE_VAULT = "By the Vault";
export const SQUARE_FOOT_ITEM = "Square Foot by Item Dimensions";
export const SQUARE_FOOT_LOCATION = "Square Foot by Location Dimensions";
export const CUBIC_FOOT_ITEM = "Cubic Foot by Item Dimensions";
export const CUBIC_FOOT_LOCATION = "Cubic Foot by Location Dimensions";
export const STORAGE_LOCATIONS_OCCUPIED = "Storage Locations Occupied";
export const FLAT_RATE = "Flat Rate/As Quoted";
export const TIME_AND_MATERIALS = "Time and Materials (T&M)";
export const TIME_AND_MATERIALS_BLENDED = "Time and Materials (Blended Rate)";
export const TIME_AND_MATERIALS_ITEMIZED = "Time and Materials (Itemized Rates)";

// Billing Type Categories (matching backend structure)
export const BY_THE_PALLET_CATEGORY = [
  BY_THE_PALLET,
  BY_THE_PALLET_WAREHOUSE_BUILT
];

export const BY_THE_UNIT_CATEGORY = [
  BY_THE_UNIT_ITEM,
  BY_THE_VAULT
];

export const BY_SQUARE_FOOTAGE_CATEGORY = [
  SQUARE_FOOT_ITEM,
  SQUARE_FOOT_LOCATION
];

export const BY_CUBIC_FOOTAGE_CATEGORY = [
  CUBIC_FOOT_ITEM,
  CUBIC_FOOT_LOCATION
];

export const BY_STORAGE_SPACE_CATEGORY = [
  STORAGE_LOCATIONS_OCCUPIED
];

export const WEIGHT_BASED_CATEGORY = [
  HUNDREDWEIGHT
];

export const OTHER_CATEGORY = [
  FLAT_RATE,
  TIME_AND_MATERIALS
];

const billingTypes = [
  HUNDREDWEIGHT,
  BY_THE_PALLET,
  BY_THE_PALLET_WAREHOUSE_BUILT,
  BY_THE_UNIT_ITEM,
  BY_THE_VAULT,
  SQUARE_FOOT_ITEM,
  SQUARE_FOOT_LOCATION,
  CUBIC_FOOT_ITEM,
  CUBIC_FOOT_LOCATION,
  STORAGE_LOCATIONS_OCCUPIED,
  FLAT_RATE,
  TIME_AND_MATERIALS,
].map(v => [v, v]);

export default billingTypes;

// Mirrors Billing::Shared::BillingTypeResolver#billing_type_direction_matches?:
// the storage minimum applies only when Hundredweight is the sole storage type.
export const isHundredweightOnly = types => types.length === 1 && types[0] === HUNDREDWEIGHT;
